namespace GeniuzPOS.InitialData {
    export interface PsCustomerSurveyPosForm {
        SurveyCode: Serenity.StringEditor;
        PosId: Serenity.StringEditor;
    }

    export class PsCustomerSurveyPosForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsCustomerSurveyPos';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsCustomerSurveyPosForm.init)  {
                PsCustomerSurveyPosForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PsCustomerSurveyPosForm, [
                    'SurveyCode', w0,
                    'PosId', w0
                ]);
            }
        }
    }
}
